export default __webpack_public_path__ + "static/media/54-min.8502e12b.jpg";